<template>
  <div>
    <div v-if="type === 0" class="pandect-module">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-trend" />
        <p class="title-text">平台总数据</p>
      </el-row>
      <div class="total-data-plane">
        <el-row type="flex" justify="space-between" align="middle" class="plane-container total-plane plane-line">
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">平台全部班型新增订单（笔）</p>
              <p class="content-num">{{ data.platTotalNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计应收入（元）</p>
              <p class="content-num">{{ [data.platTotalAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">合计基础班新增订单（笔）</p>
              <p class="content-num">{{ data.platBaseNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计应收入（元）</p>
              <p class="content-num">{{ [data.platBaseAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">合计标准班新增订单（笔）</p>
              <p class="content-num">{{ data.platStandardNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计（元）</p>
              <p class="content-num">{{ [data.platStandardAmt, 2] | toLocalString }}</p>
            </div>
          </div>
        </el-row>
        <div class="plane-container">
          <el-row type="flex" justify="space-between" align="middle" class="plane-line">
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">各代理全部班型新增订单（笔）</p>
                <p class="content-num">{{ data.agentTotalNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">应结算金额（元）</p>
                <p class="content-num">{{ [data.agentTotalSettleAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">基础班新增订单（笔）</p>
                <p class="content-num">{{ data.agentBaseNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">应结算金额（元）</p>
                <p class="content-num">{{ [data.agentBaseSettleAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">标准班新增订单（笔）</p>
                <p class="content-num">{{ data.agentStandardNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">应结算金额（元）</p>
                <p class="content-num">{{ [data.agentStandardSettleAmt, 2] | toLocalString }}</p>
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <div v-else class="agent-pandect-module">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-trend" />
        <p v-if="type === 1" class="title-text">教务服务方总数据</p>
        <p v-else-if="type === 2" class="title-text">招生服务方总数据</p>
      </el-row>
      <el-row type="flex" class="agent-total-data-plane">
        <div class="agent-plane-card card-1">
          <div class="plane-content-item">
            <p class="content-label">全部班型新增订单（笔）</p>
            <p class="content-num">{{ data.totalNum | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">业绩（元）</p>
            <p class="content-num">{{ [data.totalAmt, 2] | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">应结算金额（元）</p>
            <p class="content-num">{{ [data.totalSettleAmt, 2] | toLocalString }}</p>
          </div>
        </div>
        <div class="agent-plane-card">
          <div class="plane-content-item">
            <p class="content-label">基础班新增订单（笔）</p>
            <p class="content-num">{{ data.baseNum | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">业绩（元）</p>
            <p class="content-num">{{ [data.baseAmt, 2] | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">应结算金额（元）</p>
            <p class="content-num">{{ [data.baseSettleAmt, 2] | toLocalString }}</p>
          </div>
        </div>
        <div class="agent-plane-card">
          <div class="plane-content-item">
            <p class="content-label">标准班新增订单（笔）</p>
            <p class="content-num">{{ data.standardNum | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">业绩（元）</p>
            <p class="content-num">{{ [data.standardAmt, 2] | toLocalString }}</p>
          </div>
          <div class="plane-content-item">
            <p class="content-label">应结算金额（元）</p>
            <p class="content-num">{{ [data.standardSettleAmt, 2] | toLocalString }}</p>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plane',

  props: {
    type: {
      type: Number,
      require: true
    },
    data: {
      type: Object,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.pandect-module,
.agent-pandect-module {
  width: 100%;
  max-width: 1540px;
  padding-top: 32px;
  overflow: hidden;
}


.plane-container {
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
  border-radius: 8px;
  &.total-plane {
    background: #FFFFFF url('../../../../assets/images/platform/bg_circle.png') no-repeat 101% 0 / 174px 162px;
  }
  & + & {
    margin-top: 16px;
  }
}
.plane-line {
  width: 100%;
  height: 124px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  .plane-item {
    display: flex;
    width: 33%;
    box-sizing: border-box;
    padding: 0 2%;
    position: relative;
    white-space: nowrap;
    font-size: 0;
    &:first-child {
      width: 32%;
      padding-left: 2%;
      .content-num {
        color: #2C8CF0;
      }
    }
    &:last-child {
      width: 35%;
      padding-right: 4%;
    }
    & + .plane-item {
      &::before {
        display: block;
        content: '';
        width: 0px;
        height: 56px;
        border-left: 1px solid #E8E8E8;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }
  &.total-plane {
    .plane-item-content {
      .content-name,
      .content-num {
        font-weight: 600;
      }
    }
  }
}
.plane-item-content {
  box-sizing: border-box;
  .content-name {
    margin-right: -10%;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
    color: #2F2F2F;
  }
  .content-num {
    padding-top: 8px;
    font-family: DIN-Regular, DIN;
    line-height: 32px;
    white-space: nowrap;
    font-size: 26px;
    color: #2F2F2F;
  }
  &:first-child {
    width: 45%;
  }
  &:last-child {
    flex: 1;
    margin-left: 10%;
  }
}

.agent-plane-card {
  flex: 1;
  width: 445px;
  height: auto;
  box-sizing: border-box;
  padding: 48px;
  background-color: #FFFFFF;
  border-radius: 8px;
  .plane-content-item {
    .content-label {
      line-height: 20px;
      font-size: 14px;
      color: #2F2F2F;
    }
    .content-num {
      padding-top: 8px;
      line-height: 32px;
      font-weight: bold;
      font-size: 26px;
      color: #2F2F2F;
    }
    & + .plane-content-item {
      padding-top: 48px;
    }
  }
  &.card-1 {
    background: #FFFFFF url('../../../../assets/images/platform/bg_circle_01.png') no-repeat right top / 174px 162px;
    .content-num {
      color: #2C8CF0;
    }
  }
  & + & {
    margin-left: 16px;
  }
}
</style>
